import React from "react";

import Text from "src/components/text";

import styles from "./conversationActivityList.module.scss";
import { CreatedBy, ShareItem } from "src/types/reports";
import { calculatePercentage } from "src/services/reports.service";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface ConversationActivityItem {
  share: ShareItem;
  createdBy: CreatedBy;
  totalAssetsCount: number;
  totalRecipients: number;
}

interface ConversationActivityListItemProps {
  item: ConversationActivityItem;
  columnCount: number;
}

const ConversationActivityListItem: React.FC<ConversationActivityListItemProps> = ({ item, columnCount }) => {
  const { share, createdBy, totalAssetsCount, totalRecipients} = item;

  const formatTime = (time: number | null) =>
    time && time >= 60
      ? `${Math.round(time / 60)}m`
      : `${Math.floor(time || 0)}s`;

  const getConversationsSource = (source: string) => {
    if (source === "Paperflite QuickSend") return "Quick Send";
    if (source === "Paperflite Link") return "Link";
    return source;
  };

  const openRate = calculatePercentage(share.uniqueEmailOpens, totalRecipients);

  const clickRate = calculatePercentage(share.uniqueLinkClicks, totalRecipients);

  return (
    <div className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={share.icon?.thumbnail || DefaultAssetIcon}
          className={styles.thumbnailIcon}
          alt={share.subject}
        />
        <a
          href={`/conversations/${share.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text
                text={share.subject}
                className={styles.title}
                lines={1}
              />
            </div>
            <div className={styles.metricsData}>
              <span>{totalAssetsCount || 0} Assets</span>
              <span>{totalRecipients || 0} Recipients</span>
            </div>
          </div>
        </a>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>
          <Text
            text={`${createdBy.firstName} ${createdBy.lastName}`}
            className={styles.author}
            lines={1}
          />
        </div>
        <div className={styles.tableDataViews}>
          {new Date(share.createdDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </div>
        <div className={styles.tableDataViews}>
          {getConversationsSource(share.source)}
        </div>
        <div className={styles.tableDataViews}>
          {openRate}
        </div>
        <div className={styles.tableDataViews}>
          {clickRate}
        </div>
        <div className={styles.tableDataTime}>
          {formatTime(share.totalTimeSpent)}
        </div>
      </div>
    </div>
  );
};

export default ConversationActivityListItem;
